import { ButtonPrimary, Text3, skinVars, useScreenSize } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React from "react";
import type { CSSProperties } from "react";

export interface ButtonProps {
	styles?: CSSProperties;
	textButton: string;
	isDisabled?: boolean;
	isLoading?: boolean;
	testID?: string;
	onAction(): Promise<void> | void;
}

export const Button: React.FC<ButtonProps> = observer(
	({ textButton, isLoading = false, isDisabled = false, onAction, styles, testID = "button-primary" }) => {
		const { isDesktopOrBigger } = useScreenSize();

		return (
			<ButtonPrimary
				dataAttributes={{ testid: testID }}
				disabled={isDisabled}
				onPress={onAction}
				showSpinner={isLoading}
				style={{ width: isDesktopOrBigger ? "auto" : "100%", ...styles }}
			>
				<Text3 medium color={skinVars.colors.textButtonPrimary} textAlign="center">
					{textButton}
				</Text3>
			</ButtonPrimary>
		);
	},
);
